import React from 'react'
import { connect } from "react-redux";
import { subscriptionsActions, currencyActions, alertActions } from "_actions";
import PaymentForm from 'components/Payments/PaymentForm'

class EditSubscription extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentId: '',
            subscriptionData: {
                currency: '',
                amount: '',
                label: '',
            },
            submitting: false,
            updated: false,
        };
    }

    componentDidMount() {
        const { dispatch, match: { params: { itemId }}} = this.props
        dispatch(subscriptionsActions.getSubscription(itemId))
        dispatch(currencyActions.getAll())
    }

    componentDidUpdate(prevProps, prevState) {
        const { subscription, match: { params: { itemId }}} = this.props
        const { updated } = this.state
        if (subscription.id === itemId && ! updated) {
            this.setState({
                currentId: subscription.id,
                subscriptionData: {
                    currency: subscription.currency.id,
                    amount: subscription.amount,
                    label: subscription.label,
                },
                updated: true
            })
        }
    }


    handleChange = (event) => {
        const { target: {name, value}} = event
        this.setState(prevState => ({
            subscriptionData: {
                ...prevState.subscriptionData,
                [name]: value
            }
        }))
    }

    handleSubmit = (event) => {
        event.preventDefault()
        const { subscriptionData, currentId } = this.state
        const { dispatch } = this.props
        if (! subscriptionData.currency || ! subscriptionData.amount || ! subscriptionData.label) {
            dispatch(alertActions.error('All Form Fields are required'))
            return
        }
        this.setState({ submitting: true })
        dispatch(subscriptionsActions.updateSubscription(subscriptionData, currentId))
    }

    render() {
        const { currencies } = this.props
        const { subscriptionData, submitting } = this.state

        return (
            <div className="main-content-wrapper top-rel-100 margin-0-40">
                <PaymentForm
                    title="Edit Subscription"
                    formData={subscriptionData}
                    currencies={currencies}
                    submitting={submitting}
                    url="/subscriptions"
                    actionType="Update"
                    onChange={this.handleChange}
                    onSubmit={this.handleSubmit}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { currency: { all_currency }, subscription: { subscription }} = state;

    return {
        currencies: all_currency,
        subscription
    };
}

const editSubscriptionPage = connect(mapStateToProps)(EditSubscription);
export { editSubscriptionPage as EditSubscription };